/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AiSandboxRouteImport } from './routes/ai-sandbox'
import { Route as ApiRouteImport } from './routes/api'
import { Route as DesignSystemRouteImport } from './routes/design-system'
import { Route as DevelopersRouteImport } from './routes/developers'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingV1PreviewRouteImport } from './routes/onboarding-v1-preview'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as PolicyRouteImport } from './routes/policy'
import { Route as StartRouteImport } from './routes/start'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AppActivityRouteImport } from './routes/_app/activity'
import { Route as AppAgentsRouteImport } from './routes/_app/agents'
import { Route as AppBondsRouteImport } from './routes/_app/bonds'
import { Route as AppBoostedLimitOrdersRouteImport } from './routes/_app/boosted-limit-orders'
import { Route as AppBuildRouteImport } from './routes/_app/build'
import { Route as AppCommoditiesRouteImport } from './routes/_app/commodities'
import { Route as AppCreatePortfolioRouteImport } from './routes/_app/create-portfolio'
import { Route as AppCryptoRouteImport } from './routes/_app/crypto'
import { Route as AppCurrenciesRouteImport } from './routes/_app/currencies'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppDebugRouteImport } from './routes/_app/debug'
import { Route as AppExploreRouteImport } from './routes/_app/explore'
import { Route as AppExploreAllRouteImport } from './routes/_app/explore-all'
import { Route as AppInvestingAccountRouteImport } from './routes/_app/investing-account'
import { Route as AppOnboardingRouteImport } from './routes/_app/onboarding'
import { Route as AppOnboardingV2RouteImport } from './routes/_app/onboarding-v2'
import { Route as AppPreIpoRouteImport } from './routes/_app/pre-ipo'
import { Route as AppPrivateCreditRouteImport } from './routes/_app/private-credit'
import { Route as AppReferralsRouteImport } from './routes/_app/referrals'
import { Route as AppRewardsRouteImport } from './routes/_app/rewards'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppStocksRouteImport } from './routes/_app/stocks'
import { Route as DesignSystemIndexRouteImport } from './routes/design-system.index'
import { Route as DesignSystemSlugRouteImport } from './routes/design-system.$slug'
import { Route as RSlugRouteImport } from './routes/r.$slug'
import { Route as StartStepIdRouteImport } from './routes/start.$stepId'
import { Route as WelcomeStepIdRouteImport } from './routes/welcome.$stepId'
import { Route as AppAgentsWorkflowIdRouteImport } from './routes/_app/agents.$workflowId'
import { Route as AppAgentsTasksRouteImport } from './routes/_app/agents.tasks'
import { Route as AppCryptoSymbolRouteImport } from './routes/_app/crypto_.$symbol'
import { Route as AppOnboardingOnboardingIdRouteImport } from './routes/_app/onboarding.$onboardingId'
import { Route as AppPortfolioPortfolioInstanceIdRouteImport } from './routes/_app/portfolio.$portfolioInstanceId'
import { Route as AppReceiptReceiptIdRouteImport } from './routes/_app/receipt.$receiptId'
import { Route as AppSpPartnerRouteImport } from './routes/_app/sp.$partner'
import { Route as AppStocksSymbolRouteImport } from './routes/_app/stocks_.$symbol'
import { Route as AppStrategyBlueprintIdRouteImport } from './routes/_app/strategy.$blueprintId'
import { Route as AppSymbolSymbolRouteImport } from './routes/_app/symbol.$symbol'
import { Route as AppTemplateBlueprintIdRouteImport } from './routes/_app/template.$blueprintId'
import { Route as AppUserUserIdRouteImport } from './routes/_app/user.$userId'
import { Route as OnrampRobinhoodCallbackRouteImport } from './routes/onramp.robinhood.callback'
import { Route as AppAgentsTasksTaskIdRouteImport } from './routes/_app/agents.tasks.$taskId'
import { Route as AppAssetChainIdTokenAddressRouteImport } from './routes/_app/asset.$chainId.$tokenAddress'
import { Route as AppCryptoChainTokenAddressRouteImport } from './routes/_app/crypto_.$chain.$tokenAddress'
import { Route as AppSymbolChainIdSymbolRouteImport } from './routes/_app/symbol.$chainId.$symbol'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_app.lazy').then((d) => d.Route))
const AiSandboxRoute = AiSandboxRouteImport.update({
  id: '/ai-sandbox',
  path: '/ai-sandbox',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/ai-sandbox.lazy').then((d) => d.Route))
const ApiRoute = ApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/api.lazy').then((d) => d.Route))
const DesignSystemRoute = DesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/design-system.lazy').then((d) => d.Route))
const DevelopersRoute = DevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const OnboardingV1PreviewRoute = OnboardingV1PreviewRouteImport.update({
  id: '/onboarding-v1-preview',
  path: '/onboarding-v1-preview',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/onboarding-v1-preview.lazy').then((d) => d.Route),
)
const PlatformRoute = PlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const PolicyRoute = PolicyRouteImport.update({
  id: '/policy',
  path: '/policy',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/policy.lazy').then((d) => d.Route))
const StartRoute = StartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/start.lazy').then((d) => d.Route))
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/terms.lazy').then((d) => d.Route))
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const AppActivityRoute = AppActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/activity.lazy').then((d) => d.Route))
const AppAgentsRoute = AppAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/agents.lazy').then((d) => d.Route))
const AppBondsRoute = AppBondsRouteImport.update({
  id: '/bonds',
  path: '/bonds',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/bonds.lazy').then((d) => d.Route))
const AppBoostedLimitOrdersRoute = AppBoostedLimitOrdersRouteImport.update({
  id: '/boosted-limit-orders',
  path: '/boosted-limit-orders',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/boosted-limit-orders.lazy').then((d) => d.Route),
)
const AppBuildRoute = AppBuildRouteImport.update({
  id: '/build',
  path: '/build',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/build.lazy').then((d) => d.Route))
const AppCommoditiesRoute = AppCommoditiesRouteImport.update({
  id: '/commodities',
  path: '/commodities',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/commodities.lazy').then((d) => d.Route),
)
const AppCreatePortfolioRoute = AppCreatePortfolioRouteImport.update({
  id: '/create-portfolio',
  path: '/create-portfolio',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/create-portfolio.lazy').then((d) => d.Route),
)
const AppCryptoRoute = AppCryptoRouteImport.update({
  id: '/crypto',
  path: '/crypto',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/crypto.lazy').then((d) => d.Route))
const AppCurrenciesRoute = AppCurrenciesRouteImport.update({
  id: '/currencies',
  path: '/currencies',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/currencies.lazy').then((d) => d.Route),
)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/dashboard.lazy').then((d) => d.Route),
)
const AppDebugRoute = AppDebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/debug.lazy').then((d) => d.Route))
const AppExploreRoute = AppExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/explore.lazy').then((d) => d.Route))
const AppExploreAllRoute = AppExploreAllRouteImport.update({
  id: '/explore-all',
  path: '/explore-all',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/explore-all.lazy').then((d) => d.Route),
)
const AppInvestingAccountRoute = AppInvestingAccountRouteImport.update({
  id: '/investing-account',
  path: '/investing-account',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/investing-account.lazy').then((d) => d.Route),
)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingV2Route = AppOnboardingV2RouteImport.update({
  id: '/onboarding-v2',
  path: '/onboarding-v2',
  getParentRoute: () => AppRoute,
} as any)
const AppPreIpoRoute = AppPreIpoRouteImport.update({
  id: '/pre-ipo',
  path: '/pre-ipo',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/pre-ipo.lazy').then((d) => d.Route))
const AppPrivateCreditRoute = AppPrivateCreditRouteImport.update({
  id: '/private-credit',
  path: '/private-credit',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/private-credit.lazy').then((d) => d.Route),
)
const AppReferralsRoute = AppReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/referrals.lazy').then((d) => d.Route),
)
const AppRewardsRoute = AppRewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/rewards.lazy').then((d) => d.Route))
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/settings.lazy').then((d) => d.Route))
const AppStocksRoute = AppStocksRouteImport.update({
  id: '/stocks',
  path: '/stocks',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/stocks.lazy').then((d) => d.Route))
const DesignSystemIndexRoute = DesignSystemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DesignSystemRoute,
} as any).lazy(() =>
  import('./routes/design-system.index.lazy').then((d) => d.Route),
)
const DesignSystemSlugRoute = DesignSystemSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => DesignSystemRoute,
} as any).lazy(() =>
  import('./routes/design-system.$slug.lazy').then((d) => d.Route),
)
const RSlugRoute = RSlugRouteImport.update({
  id: '/r/$slug',
  path: '/r/$slug',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/r.$slug.lazy').then((d) => d.Route))
const StartStepIdRoute = StartStepIdRouteImport.update({
  id: '/$stepId',
  path: '/$stepId',
  getParentRoute: () => StartRoute,
} as any).lazy(() => import('./routes/start.$stepId.lazy').then((d) => d.Route))
const WelcomeStepIdRoute = WelcomeStepIdRouteImport.update({
  id: '/$stepId',
  path: '/$stepId',
  getParentRoute: () => WelcomeRoute,
} as any).lazy(() =>
  import('./routes/welcome.$stepId.lazy').then((d) => d.Route),
)
const AppAgentsWorkflowIdRoute = AppAgentsWorkflowIdRouteImport.update({
  id: '/$workflowId',
  path: '/$workflowId',
  getParentRoute: () => AppAgentsRoute,
} as any).lazy(() =>
  import('./routes/_app/agents.$workflowId.lazy').then((d) => d.Route),
)
const AppAgentsTasksRoute = AppAgentsTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppAgentsRoute,
} as any).lazy(() =>
  import('./routes/_app/agents.tasks.lazy').then((d) => d.Route),
)
const AppCryptoSymbolRoute = AppCryptoSymbolRouteImport.update({
  id: '/crypto_/$symbol',
  path: '/crypto/$symbol',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/crypto_.$symbol.lazy').then((d) => d.Route),
)
const AppOnboardingOnboardingIdRoute =
  AppOnboardingOnboardingIdRouteImport.update({
    id: '/$onboardingId',
    path: '/$onboardingId',
    getParentRoute: () => AppOnboardingRoute,
  } as any).lazy(() =>
    import('./routes/_app/onboarding.$onboardingId.lazy').then((d) => d.Route),
  )
const AppPortfolioPortfolioInstanceIdRoute =
  AppPortfolioPortfolioInstanceIdRouteImport.update({
    id: '/portfolio/$portfolioInstanceId',
    path: '/portfolio/$portfolioInstanceId',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/portfolio.$portfolioInstanceId.lazy').then(
      (d) => d.Route,
    ),
  )
const AppReceiptReceiptIdRoute = AppReceiptReceiptIdRouteImport.update({
  id: '/receipt/$receiptId',
  path: '/receipt/$receiptId',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/receipt.$receiptId.lazy').then((d) => d.Route),
)
const AppSpPartnerRoute = AppSpPartnerRouteImport.update({
  id: '/sp/$partner',
  path: '/sp/$partner',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/sp.$partner.lazy').then((d) => d.Route),
)
const AppStocksSymbolRoute = AppStocksSymbolRouteImport.update({
  id: '/stocks_/$symbol',
  path: '/stocks/$symbol',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stocks_.$symbol.lazy').then((d) => d.Route),
)
const AppStrategyBlueprintIdRoute = AppStrategyBlueprintIdRouteImport.update({
  id: '/strategy/$blueprintId',
  path: '/strategy/$blueprintId',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/strategy.$blueprintId.lazy').then((d) => d.Route),
)
const AppSymbolSymbolRoute = AppSymbolSymbolRouteImport.update({
  id: '/symbol/$symbol',
  path: '/symbol/$symbol',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/symbol.$symbol.lazy').then((d) => d.Route),
)
const AppTemplateBlueprintIdRoute = AppTemplateBlueprintIdRouteImport.update({
  id: '/template/$blueprintId',
  path: '/template/$blueprintId',
  getParentRoute: () => AppRoute,
} as any)
const AppUserUserIdRoute = AppUserUserIdRouteImport.update({
  id: '/user/$userId',
  path: '/user/$userId',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/user.$userId.lazy').then((d) => d.Route),
)
const OnrampRobinhoodCallbackRoute = OnrampRobinhoodCallbackRouteImport.update({
  id: '/onramp/robinhood/callback',
  path: '/onramp/robinhood/callback',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/onramp.robinhood.callback.lazy').then((d) => d.Route),
)
const AppAgentsTasksTaskIdRoute = AppAgentsTasksTaskIdRouteImport.update({
  id: '/$taskId',
  path: '/$taskId',
  getParentRoute: () => AppAgentsTasksRoute,
} as any).lazy(() =>
  import('./routes/_app/agents.tasks.$taskId.lazy').then((d) => d.Route),
)
const AppAssetChainIdTokenAddressRoute =
  AppAssetChainIdTokenAddressRouteImport.update({
    id: '/asset/$chainId/$tokenAddress',
    path: '/asset/$chainId/$tokenAddress',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/asset.$chainId.$tokenAddress.lazy').then(
      (d) => d.Route,
    ),
  )
const AppCryptoChainTokenAddressRoute =
  AppCryptoChainTokenAddressRouteImport.update({
    id: '/crypto_/$chain/$tokenAddress',
    path: '/crypto/$chain/$tokenAddress',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/crypto_.$chain.$tokenAddress.lazy').then(
      (d) => d.Route,
    ),
  )
const AppSymbolChainIdSymbolRoute = AppSymbolChainIdSymbolRouteImport.update({
  id: '/symbol/$chainId/$symbol',
  path: '/symbol/$chainId/$symbol',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/symbol.$chainId.$symbol.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai-sandbox': typeof AiSandboxRoute
  '/api': typeof ApiRoute
  '/design-system': typeof DesignSystemRouteWithChildren
  '/developers': typeof DevelopersRoute
  '/login': typeof LoginRoute
  '/onboarding-v1-preview': typeof OnboardingV1PreviewRoute
  '/platform': typeof PlatformRoute
  '/policy': typeof PolicyRoute
  '/start': typeof StartRouteWithChildren
  '/terms': typeof TermsRoute
  '/welcome': typeof WelcomeRouteWithChildren
  '/activity': typeof AppActivityRoute
  '/agents': typeof AppAgentsRouteWithChildren
  '/bonds': typeof AppBondsRoute
  '/boosted-limit-orders': typeof AppBoostedLimitOrdersRoute
  '/build': typeof AppBuildRoute
  '/commodities': typeof AppCommoditiesRoute
  '/create-portfolio': typeof AppCreatePortfolioRoute
  '/crypto': typeof AppCryptoRoute
  '/currencies': typeof AppCurrenciesRoute
  '/dashboard': typeof AppDashboardRoute
  '/debug': typeof AppDebugRoute
  '/explore': typeof AppExploreRoute
  '/explore-all': typeof AppExploreAllRoute
  '/investing-account': typeof AppInvestingAccountRoute
  '/onboarding': typeof AppOnboardingRouteWithChildren
  '/onboarding-v2': typeof AppOnboardingV2Route
  '/pre-ipo': typeof AppPreIpoRoute
  '/private-credit': typeof AppPrivateCreditRoute
  '/referrals': typeof AppReferralsRoute
  '/rewards': typeof AppRewardsRoute
  '/settings': typeof AppSettingsRoute
  '/stocks': typeof AppStocksRoute
  '/design-system/$slug': typeof DesignSystemSlugRoute
  '/r/$slug': typeof RSlugRoute
  '/start/$stepId': typeof StartStepIdRoute
  '/welcome/$stepId': typeof WelcomeStepIdRoute
  '/design-system/': typeof DesignSystemIndexRoute
  '/agents/$workflowId': typeof AppAgentsWorkflowIdRoute
  '/agents/tasks': typeof AppAgentsTasksRouteWithChildren
  '/crypto/$symbol': typeof AppCryptoSymbolRoute
  '/onboarding/$onboardingId': typeof AppOnboardingOnboardingIdRoute
  '/portfolio/$portfolioInstanceId': typeof AppPortfolioPortfolioInstanceIdRoute
  '/receipt/$receiptId': typeof AppReceiptReceiptIdRoute
  '/sp/$partner': typeof AppSpPartnerRoute
  '/stocks/$symbol': typeof AppStocksSymbolRoute
  '/strategy/$blueprintId': typeof AppStrategyBlueprintIdRoute
  '/symbol/$symbol': typeof AppSymbolSymbolRoute
  '/template/$blueprintId': typeof AppTemplateBlueprintIdRoute
  '/user/$userId': typeof AppUserUserIdRoute
  '/onramp/robinhood/callback': typeof OnrampRobinhoodCallbackRoute
  '/agents/tasks/$taskId': typeof AppAgentsTasksTaskIdRoute
  '/asset/$chainId/$tokenAddress': typeof AppAssetChainIdTokenAddressRoute
  '/crypto/$chain/$tokenAddress': typeof AppCryptoChainTokenAddressRoute
  '/symbol/$chainId/$symbol': typeof AppSymbolChainIdSymbolRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ai-sandbox': typeof AiSandboxRoute
  '/api': typeof ApiRoute
  '/developers': typeof DevelopersRoute
  '/login': typeof LoginRoute
  '/onboarding-v1-preview': typeof OnboardingV1PreviewRoute
  '/platform': typeof PlatformRoute
  '/policy': typeof PolicyRoute
  '/start': typeof StartRouteWithChildren
  '/terms': typeof TermsRoute
  '/welcome': typeof WelcomeRouteWithChildren
  '/activity': typeof AppActivityRoute
  '/agents': typeof AppAgentsRouteWithChildren
  '/bonds': typeof AppBondsRoute
  '/boosted-limit-orders': typeof AppBoostedLimitOrdersRoute
  '/build': typeof AppBuildRoute
  '/commodities': typeof AppCommoditiesRoute
  '/create-portfolio': typeof AppCreatePortfolioRoute
  '/crypto': typeof AppCryptoRoute
  '/currencies': typeof AppCurrenciesRoute
  '/dashboard': typeof AppDashboardRoute
  '/debug': typeof AppDebugRoute
  '/explore': typeof AppExploreRoute
  '/explore-all': typeof AppExploreAllRoute
  '/investing-account': typeof AppInvestingAccountRoute
  '/onboarding': typeof AppOnboardingRouteWithChildren
  '/onboarding-v2': typeof AppOnboardingV2Route
  '/pre-ipo': typeof AppPreIpoRoute
  '/private-credit': typeof AppPrivateCreditRoute
  '/referrals': typeof AppReferralsRoute
  '/rewards': typeof AppRewardsRoute
  '/settings': typeof AppSettingsRoute
  '/stocks': typeof AppStocksRoute
  '/design-system/$slug': typeof DesignSystemSlugRoute
  '/r/$slug': typeof RSlugRoute
  '/start/$stepId': typeof StartStepIdRoute
  '/welcome/$stepId': typeof WelcomeStepIdRoute
  '/design-system': typeof DesignSystemIndexRoute
  '/agents/$workflowId': typeof AppAgentsWorkflowIdRoute
  '/agents/tasks': typeof AppAgentsTasksRouteWithChildren
  '/crypto/$symbol': typeof AppCryptoSymbolRoute
  '/onboarding/$onboardingId': typeof AppOnboardingOnboardingIdRoute
  '/portfolio/$portfolioInstanceId': typeof AppPortfolioPortfolioInstanceIdRoute
  '/receipt/$receiptId': typeof AppReceiptReceiptIdRoute
  '/sp/$partner': typeof AppSpPartnerRoute
  '/stocks/$symbol': typeof AppStocksSymbolRoute
  '/strategy/$blueprintId': typeof AppStrategyBlueprintIdRoute
  '/symbol/$symbol': typeof AppSymbolSymbolRoute
  '/template/$blueprintId': typeof AppTemplateBlueprintIdRoute
  '/user/$userId': typeof AppUserUserIdRoute
  '/onramp/robinhood/callback': typeof OnrampRobinhoodCallbackRoute
  '/agents/tasks/$taskId': typeof AppAgentsTasksTaskIdRoute
  '/asset/$chainId/$tokenAddress': typeof AppAssetChainIdTokenAddressRoute
  '/crypto/$chain/$tokenAddress': typeof AppCryptoChainTokenAddressRoute
  '/symbol/$chainId/$symbol': typeof AppSymbolChainIdSymbolRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/ai-sandbox': typeof AiSandboxRoute
  '/api': typeof ApiRoute
  '/design-system': typeof DesignSystemRouteWithChildren
  '/developers': typeof DevelopersRoute
  '/login': typeof LoginRoute
  '/onboarding-v1-preview': typeof OnboardingV1PreviewRoute
  '/platform': typeof PlatformRoute
  '/policy': typeof PolicyRoute
  '/start': typeof StartRouteWithChildren
  '/terms': typeof TermsRoute
  '/welcome': typeof WelcomeRouteWithChildren
  '/_app/activity': typeof AppActivityRoute
  '/_app/agents': typeof AppAgentsRouteWithChildren
  '/_app/bonds': typeof AppBondsRoute
  '/_app/boosted-limit-orders': typeof AppBoostedLimitOrdersRoute
  '/_app/build': typeof AppBuildRoute
  '/_app/commodities': typeof AppCommoditiesRoute
  '/_app/create-portfolio': typeof AppCreatePortfolioRoute
  '/_app/crypto': typeof AppCryptoRoute
  '/_app/currencies': typeof AppCurrenciesRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/debug': typeof AppDebugRoute
  '/_app/explore': typeof AppExploreRoute
  '/_app/explore-all': typeof AppExploreAllRoute
  '/_app/investing-account': typeof AppInvestingAccountRoute
  '/_app/onboarding': typeof AppOnboardingRouteWithChildren
  '/_app/onboarding-v2': typeof AppOnboardingV2Route
  '/_app/pre-ipo': typeof AppPreIpoRoute
  '/_app/private-credit': typeof AppPrivateCreditRoute
  '/_app/referrals': typeof AppReferralsRoute
  '/_app/rewards': typeof AppRewardsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/stocks': typeof AppStocksRoute
  '/design-system/$slug': typeof DesignSystemSlugRoute
  '/r/$slug': typeof RSlugRoute
  '/start/$stepId': typeof StartStepIdRoute
  '/welcome/$stepId': typeof WelcomeStepIdRoute
  '/design-system/': typeof DesignSystemIndexRoute
  '/_app/agents/$workflowId': typeof AppAgentsWorkflowIdRoute
  '/_app/agents/tasks': typeof AppAgentsTasksRouteWithChildren
  '/_app/crypto_/$symbol': typeof AppCryptoSymbolRoute
  '/_app/onboarding/$onboardingId': typeof AppOnboardingOnboardingIdRoute
  '/_app/portfolio/$portfolioInstanceId': typeof AppPortfolioPortfolioInstanceIdRoute
  '/_app/receipt/$receiptId': typeof AppReceiptReceiptIdRoute
  '/_app/sp/$partner': typeof AppSpPartnerRoute
  '/_app/stocks_/$symbol': typeof AppStocksSymbolRoute
  '/_app/strategy/$blueprintId': typeof AppStrategyBlueprintIdRoute
  '/_app/symbol/$symbol': typeof AppSymbolSymbolRoute
  '/_app/template/$blueprintId': typeof AppTemplateBlueprintIdRoute
  '/_app/user/$userId': typeof AppUserUserIdRoute
  '/onramp/robinhood/callback': typeof OnrampRobinhoodCallbackRoute
  '/_app/agents/tasks/$taskId': typeof AppAgentsTasksTaskIdRoute
  '/_app/asset/$chainId/$tokenAddress': typeof AppAssetChainIdTokenAddressRoute
  '/_app/crypto_/$chain/$tokenAddress': typeof AppCryptoChainTokenAddressRoute
  '/_app/symbol/$chainId/$symbol': typeof AppSymbolChainIdSymbolRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai-sandbox'
    | '/api'
    | '/design-system'
    | '/developers'
    | '/login'
    | '/onboarding-v1-preview'
    | '/platform'
    | '/policy'
    | '/start'
    | '/terms'
    | '/welcome'
    | '/activity'
    | '/agents'
    | '/bonds'
    | '/boosted-limit-orders'
    | '/build'
    | '/commodities'
    | '/create-portfolio'
    | '/crypto'
    | '/currencies'
    | '/dashboard'
    | '/debug'
    | '/explore'
    | '/explore-all'
    | '/investing-account'
    | '/onboarding'
    | '/onboarding-v2'
    | '/pre-ipo'
    | '/private-credit'
    | '/referrals'
    | '/rewards'
    | '/settings'
    | '/stocks'
    | '/design-system/$slug'
    | '/r/$slug'
    | '/start/$stepId'
    | '/welcome/$stepId'
    | '/design-system/'
    | '/agents/$workflowId'
    | '/agents/tasks'
    | '/crypto/$symbol'
    | '/onboarding/$onboardingId'
    | '/portfolio/$portfolioInstanceId'
    | '/receipt/$receiptId'
    | '/sp/$partner'
    | '/stocks/$symbol'
    | '/strategy/$blueprintId'
    | '/symbol/$symbol'
    | '/template/$blueprintId'
    | '/user/$userId'
    | '/onramp/robinhood/callback'
    | '/agents/tasks/$taskId'
    | '/asset/$chainId/$tokenAddress'
    | '/crypto/$chain/$tokenAddress'
    | '/symbol/$chainId/$symbol'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ai-sandbox'
    | '/api'
    | '/developers'
    | '/login'
    | '/onboarding-v1-preview'
    | '/platform'
    | '/policy'
    | '/start'
    | '/terms'
    | '/welcome'
    | '/activity'
    | '/agents'
    | '/bonds'
    | '/boosted-limit-orders'
    | '/build'
    | '/commodities'
    | '/create-portfolio'
    | '/crypto'
    | '/currencies'
    | '/dashboard'
    | '/debug'
    | '/explore'
    | '/explore-all'
    | '/investing-account'
    | '/onboarding'
    | '/onboarding-v2'
    | '/pre-ipo'
    | '/private-credit'
    | '/referrals'
    | '/rewards'
    | '/settings'
    | '/stocks'
    | '/design-system/$slug'
    | '/r/$slug'
    | '/start/$stepId'
    | '/welcome/$stepId'
    | '/design-system'
    | '/agents/$workflowId'
    | '/agents/tasks'
    | '/crypto/$symbol'
    | '/onboarding/$onboardingId'
    | '/portfolio/$portfolioInstanceId'
    | '/receipt/$receiptId'
    | '/sp/$partner'
    | '/stocks/$symbol'
    | '/strategy/$blueprintId'
    | '/symbol/$symbol'
    | '/template/$blueprintId'
    | '/user/$userId'
    | '/onramp/robinhood/callback'
    | '/agents/tasks/$taskId'
    | '/asset/$chainId/$tokenAddress'
    | '/crypto/$chain/$tokenAddress'
    | '/symbol/$chainId/$symbol'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/ai-sandbox'
    | '/api'
    | '/design-system'
    | '/developers'
    | '/login'
    | '/onboarding-v1-preview'
    | '/platform'
    | '/policy'
    | '/start'
    | '/terms'
    | '/welcome'
    | '/_app/activity'
    | '/_app/agents'
    | '/_app/bonds'
    | '/_app/boosted-limit-orders'
    | '/_app/build'
    | '/_app/commodities'
    | '/_app/create-portfolio'
    | '/_app/crypto'
    | '/_app/currencies'
    | '/_app/dashboard'
    | '/_app/debug'
    | '/_app/explore'
    | '/_app/explore-all'
    | '/_app/investing-account'
    | '/_app/onboarding'
    | '/_app/onboarding-v2'
    | '/_app/pre-ipo'
    | '/_app/private-credit'
    | '/_app/referrals'
    | '/_app/rewards'
    | '/_app/settings'
    | '/_app/stocks'
    | '/design-system/$slug'
    | '/r/$slug'
    | '/start/$stepId'
    | '/welcome/$stepId'
    | '/design-system/'
    | '/_app/agents/$workflowId'
    | '/_app/agents/tasks'
    | '/_app/crypto_/$symbol'
    | '/_app/onboarding/$onboardingId'
    | '/_app/portfolio/$portfolioInstanceId'
    | '/_app/receipt/$receiptId'
    | '/_app/sp/$partner'
    | '/_app/stocks_/$symbol'
    | '/_app/strategy/$blueprintId'
    | '/_app/symbol/$symbol'
    | '/_app/template/$blueprintId'
    | '/_app/user/$userId'
    | '/onramp/robinhood/callback'
    | '/_app/agents/tasks/$taskId'
    | '/_app/asset/$chainId/$tokenAddress'
    | '/_app/crypto_/$chain/$tokenAddress'
    | '/_app/symbol/$chainId/$symbol'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AiSandboxRoute: typeof AiSandboxRoute
  ApiRoute: typeof ApiRoute
  DesignSystemRoute: typeof DesignSystemRouteWithChildren
  DevelopersRoute: typeof DevelopersRoute
  LoginRoute: typeof LoginRoute
  OnboardingV1PreviewRoute: typeof OnboardingV1PreviewRoute
  PlatformRoute: typeof PlatformRoute
  PolicyRoute: typeof PolicyRoute
  StartRoute: typeof StartRouteWithChildren
  TermsRoute: typeof TermsRoute
  WelcomeRoute: typeof WelcomeRouteWithChildren
  RSlugRoute: typeof RSlugRoute
  OnrampRobinhoodCallbackRoute: typeof OnrampRobinhoodCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-sandbox': {
      id: '/ai-sandbox'
      path: '/ai-sandbox'
      fullPath: '/ai-sandbox'
      preLoaderRoute: typeof AiSandboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api': {
      id: '/api'
      path: '/api'
      fullPath: '/api'
      preLoaderRoute: typeof ApiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design-system': {
      id: '/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof DesignSystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developers': {
      id: '/developers'
      path: '/developers'
      fullPath: '/developers'
      preLoaderRoute: typeof DevelopersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding-v1-preview': {
      id: '/onboarding-v1-preview'
      path: '/onboarding-v1-preview'
      fullPath: '/onboarding-v1-preview'
      preLoaderRoute: typeof OnboardingV1PreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform': {
      id: '/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof PlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policy': {
      id: '/policy'
      path: '/policy'
      fullPath: '/policy'
      preLoaderRoute: typeof PolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents': {
      id: '/_app/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AppAgentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bonds': {
      id: '/_app/bonds'
      path: '/bonds'
      fullPath: '/bonds'
      preLoaderRoute: typeof AppBondsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/boosted-limit-orders': {
      id: '/_app/boosted-limit-orders'
      path: '/boosted-limit-orders'
      fullPath: '/boosted-limit-orders'
      preLoaderRoute: typeof AppBoostedLimitOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/build': {
      id: '/_app/build'
      path: '/build'
      fullPath: '/build'
      preLoaderRoute: typeof AppBuildRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/commodities': {
      id: '/_app/commodities'
      path: '/commodities'
      fullPath: '/commodities'
      preLoaderRoute: typeof AppCommoditiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/create-portfolio': {
      id: '/_app/create-portfolio'
      path: '/create-portfolio'
      fullPath: '/create-portfolio'
      preLoaderRoute: typeof AppCreatePortfolioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/crypto': {
      id: '/_app/crypto'
      path: '/crypto'
      fullPath: '/crypto'
      preLoaderRoute: typeof AppCryptoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/currencies': {
      id: '/_app/currencies'
      path: '/currencies'
      fullPath: '/currencies'
      preLoaderRoute: typeof AppCurrenciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/debug': {
      id: '/_app/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof AppDebugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/explore': {
      id: '/_app/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof AppExploreRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/explore-all': {
      id: '/_app/explore-all'
      path: '/explore-all'
      fullPath: '/explore-all'
      preLoaderRoute: typeof AppExploreAllRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/investing-account': {
      id: '/_app/investing-account'
      path: '/investing-account'
      fullPath: '/investing-account'
      preLoaderRoute: typeof AppInvestingAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding': {
      id: '/_app/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding-v2': {
      id: '/_app/onboarding-v2'
      path: '/onboarding-v2'
      fullPath: '/onboarding-v2'
      preLoaderRoute: typeof AppOnboardingV2RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pre-ipo': {
      id: '/_app/pre-ipo'
      path: '/pre-ipo'
      fullPath: '/pre-ipo'
      preLoaderRoute: typeof AppPreIpoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/private-credit': {
      id: '/_app/private-credit'
      path: '/private-credit'
      fullPath: '/private-credit'
      preLoaderRoute: typeof AppPrivateCreditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/referrals': {
      id: '/_app/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AppReferralsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rewards': {
      id: '/_app/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof AppRewardsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stocks': {
      id: '/_app/stocks'
      path: '/stocks'
      fullPath: '/stocks'
      preLoaderRoute: typeof AppStocksRouteImport
      parentRoute: typeof AppRoute
    }
    '/design-system/': {
      id: '/design-system/'
      path: '/'
      fullPath: '/design-system/'
      preLoaderRoute: typeof DesignSystemIndexRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/design-system/$slug': {
      id: '/design-system/$slug'
      path: '/$slug'
      fullPath: '/design-system/$slug'
      preLoaderRoute: typeof DesignSystemSlugRouteImport
      parentRoute: typeof DesignSystemRoute
    }
    '/r/$slug': {
      id: '/r/$slug'
      path: '/r/$slug'
      fullPath: '/r/$slug'
      preLoaderRoute: typeof RSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start/$stepId': {
      id: '/start/$stepId'
      path: '/$stepId'
      fullPath: '/start/$stepId'
      preLoaderRoute: typeof StartStepIdRouteImport
      parentRoute: typeof StartRoute
    }
    '/welcome/$stepId': {
      id: '/welcome/$stepId'
      path: '/$stepId'
      fullPath: '/welcome/$stepId'
      preLoaderRoute: typeof WelcomeStepIdRouteImport
      parentRoute: typeof WelcomeRoute
    }
    '/_app/agents/$workflowId': {
      id: '/_app/agents/$workflowId'
      path: '/$workflowId'
      fullPath: '/agents/$workflowId'
      preLoaderRoute: typeof AppAgentsWorkflowIdRouteImport
      parentRoute: typeof AppAgentsRoute
    }
    '/_app/agents/tasks': {
      id: '/_app/agents/tasks'
      path: '/tasks'
      fullPath: '/agents/tasks'
      preLoaderRoute: typeof AppAgentsTasksRouteImport
      parentRoute: typeof AppAgentsRoute
    }
    '/_app/crypto_/$symbol': {
      id: '/_app/crypto_/$symbol'
      path: '/crypto/$symbol'
      fullPath: '/crypto/$symbol'
      preLoaderRoute: typeof AppCryptoSymbolRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/$onboardingId': {
      id: '/_app/onboarding/$onboardingId'
      path: '/$onboardingId'
      fullPath: '/onboarding/$onboardingId'
      preLoaderRoute: typeof AppOnboardingOnboardingIdRouteImport
      parentRoute: typeof AppOnboardingRoute
    }
    '/_app/portfolio/$portfolioInstanceId': {
      id: '/_app/portfolio/$portfolioInstanceId'
      path: '/portfolio/$portfolioInstanceId'
      fullPath: '/portfolio/$portfolioInstanceId'
      preLoaderRoute: typeof AppPortfolioPortfolioInstanceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/receipt/$receiptId': {
      id: '/_app/receipt/$receiptId'
      path: '/receipt/$receiptId'
      fullPath: '/receipt/$receiptId'
      preLoaderRoute: typeof AppReceiptReceiptIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sp/$partner': {
      id: '/_app/sp/$partner'
      path: '/sp/$partner'
      fullPath: '/sp/$partner'
      preLoaderRoute: typeof AppSpPartnerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stocks_/$symbol': {
      id: '/_app/stocks_/$symbol'
      path: '/stocks/$symbol'
      fullPath: '/stocks/$symbol'
      preLoaderRoute: typeof AppStocksSymbolRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/strategy/$blueprintId': {
      id: '/_app/strategy/$blueprintId'
      path: '/strategy/$blueprintId'
      fullPath: '/strategy/$blueprintId'
      preLoaderRoute: typeof AppStrategyBlueprintIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/symbol/$symbol': {
      id: '/_app/symbol/$symbol'
      path: '/symbol/$symbol'
      fullPath: '/symbol/$symbol'
      preLoaderRoute: typeof AppSymbolSymbolRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/template/$blueprintId': {
      id: '/_app/template/$blueprintId'
      path: '/template/$blueprintId'
      fullPath: '/template/$blueprintId'
      preLoaderRoute: typeof AppTemplateBlueprintIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/user/$userId': {
      id: '/_app/user/$userId'
      path: '/user/$userId'
      fullPath: '/user/$userId'
      preLoaderRoute: typeof AppUserUserIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/onramp/robinhood/callback': {
      id: '/onramp/robinhood/callback'
      path: '/onramp/robinhood/callback'
      fullPath: '/onramp/robinhood/callback'
      preLoaderRoute: typeof OnrampRobinhoodCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/agents/tasks/$taskId': {
      id: '/_app/agents/tasks/$taskId'
      path: '/$taskId'
      fullPath: '/agents/tasks/$taskId'
      preLoaderRoute: typeof AppAgentsTasksTaskIdRouteImport
      parentRoute: typeof AppAgentsTasksRoute
    }
    '/_app/asset/$chainId/$tokenAddress': {
      id: '/_app/asset/$chainId/$tokenAddress'
      path: '/asset/$chainId/$tokenAddress'
      fullPath: '/asset/$chainId/$tokenAddress'
      preLoaderRoute: typeof AppAssetChainIdTokenAddressRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/crypto_/$chain/$tokenAddress': {
      id: '/_app/crypto_/$chain/$tokenAddress'
      path: '/crypto/$chain/$tokenAddress'
      fullPath: '/crypto/$chain/$tokenAddress'
      preLoaderRoute: typeof AppCryptoChainTokenAddressRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/symbol/$chainId/$symbol': {
      id: '/_app/symbol/$chainId/$symbol'
      path: '/symbol/$chainId/$symbol'
      fullPath: '/symbol/$chainId/$symbol'
      preLoaderRoute: typeof AppSymbolChainIdSymbolRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppAgentsTasksRouteChildren {
  AppAgentsTasksTaskIdRoute: typeof AppAgentsTasksTaskIdRoute
}

const AppAgentsTasksRouteChildren: AppAgentsTasksRouteChildren = {
  AppAgentsTasksTaskIdRoute: AppAgentsTasksTaskIdRoute,
}

const AppAgentsTasksRouteWithChildren = AppAgentsTasksRoute._addFileChildren(
  AppAgentsTasksRouteChildren,
)

interface AppAgentsRouteChildren {
  AppAgentsWorkflowIdRoute: typeof AppAgentsWorkflowIdRoute
  AppAgentsTasksRoute: typeof AppAgentsTasksRouteWithChildren
}

const AppAgentsRouteChildren: AppAgentsRouteChildren = {
  AppAgentsWorkflowIdRoute: AppAgentsWorkflowIdRoute,
  AppAgentsTasksRoute: AppAgentsTasksRouteWithChildren,
}

const AppAgentsRouteWithChildren = AppAgentsRoute._addFileChildren(
  AppAgentsRouteChildren,
)

interface AppOnboardingRouteChildren {
  AppOnboardingOnboardingIdRoute: typeof AppOnboardingOnboardingIdRoute
}

const AppOnboardingRouteChildren: AppOnboardingRouteChildren = {
  AppOnboardingOnboardingIdRoute: AppOnboardingOnboardingIdRoute,
}

const AppOnboardingRouteWithChildren = AppOnboardingRoute._addFileChildren(
  AppOnboardingRouteChildren,
)

interface AppRouteChildren {
  AppActivityRoute: typeof AppActivityRoute
  AppAgentsRoute: typeof AppAgentsRouteWithChildren
  AppBondsRoute: typeof AppBondsRoute
  AppBoostedLimitOrdersRoute: typeof AppBoostedLimitOrdersRoute
  AppBuildRoute: typeof AppBuildRoute
  AppCommoditiesRoute: typeof AppCommoditiesRoute
  AppCreatePortfolioRoute: typeof AppCreatePortfolioRoute
  AppCryptoRoute: typeof AppCryptoRoute
  AppCurrenciesRoute: typeof AppCurrenciesRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDebugRoute: typeof AppDebugRoute
  AppExploreRoute: typeof AppExploreRoute
  AppExploreAllRoute: typeof AppExploreAllRoute
  AppInvestingAccountRoute: typeof AppInvestingAccountRoute
  AppOnboardingRoute: typeof AppOnboardingRouteWithChildren
  AppOnboardingV2Route: typeof AppOnboardingV2Route
  AppPreIpoRoute: typeof AppPreIpoRoute
  AppPrivateCreditRoute: typeof AppPrivateCreditRoute
  AppReferralsRoute: typeof AppReferralsRoute
  AppRewardsRoute: typeof AppRewardsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppStocksRoute: typeof AppStocksRoute
  AppCryptoSymbolRoute: typeof AppCryptoSymbolRoute
  AppPortfolioPortfolioInstanceIdRoute: typeof AppPortfolioPortfolioInstanceIdRoute
  AppReceiptReceiptIdRoute: typeof AppReceiptReceiptIdRoute
  AppSpPartnerRoute: typeof AppSpPartnerRoute
  AppStocksSymbolRoute: typeof AppStocksSymbolRoute
  AppStrategyBlueprintIdRoute: typeof AppStrategyBlueprintIdRoute
  AppSymbolSymbolRoute: typeof AppSymbolSymbolRoute
  AppTemplateBlueprintIdRoute: typeof AppTemplateBlueprintIdRoute
  AppUserUserIdRoute: typeof AppUserUserIdRoute
  AppAssetChainIdTokenAddressRoute: typeof AppAssetChainIdTokenAddressRoute
  AppCryptoChainTokenAddressRoute: typeof AppCryptoChainTokenAddressRoute
  AppSymbolChainIdSymbolRoute: typeof AppSymbolChainIdSymbolRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActivityRoute: AppActivityRoute,
  AppAgentsRoute: AppAgentsRouteWithChildren,
  AppBondsRoute: AppBondsRoute,
  AppBoostedLimitOrdersRoute: AppBoostedLimitOrdersRoute,
  AppBuildRoute: AppBuildRoute,
  AppCommoditiesRoute: AppCommoditiesRoute,
  AppCreatePortfolioRoute: AppCreatePortfolioRoute,
  AppCryptoRoute: AppCryptoRoute,
  AppCurrenciesRoute: AppCurrenciesRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDebugRoute: AppDebugRoute,
  AppExploreRoute: AppExploreRoute,
  AppExploreAllRoute: AppExploreAllRoute,
  AppInvestingAccountRoute: AppInvestingAccountRoute,
  AppOnboardingRoute: AppOnboardingRouteWithChildren,
  AppOnboardingV2Route: AppOnboardingV2Route,
  AppPreIpoRoute: AppPreIpoRoute,
  AppPrivateCreditRoute: AppPrivateCreditRoute,
  AppReferralsRoute: AppReferralsRoute,
  AppRewardsRoute: AppRewardsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppStocksRoute: AppStocksRoute,
  AppCryptoSymbolRoute: AppCryptoSymbolRoute,
  AppPortfolioPortfolioInstanceIdRoute: AppPortfolioPortfolioInstanceIdRoute,
  AppReceiptReceiptIdRoute: AppReceiptReceiptIdRoute,
  AppSpPartnerRoute: AppSpPartnerRoute,
  AppStocksSymbolRoute: AppStocksSymbolRoute,
  AppStrategyBlueprintIdRoute: AppStrategyBlueprintIdRoute,
  AppSymbolSymbolRoute: AppSymbolSymbolRoute,
  AppTemplateBlueprintIdRoute: AppTemplateBlueprintIdRoute,
  AppUserUserIdRoute: AppUserUserIdRoute,
  AppAssetChainIdTokenAddressRoute: AppAssetChainIdTokenAddressRoute,
  AppCryptoChainTokenAddressRoute: AppCryptoChainTokenAddressRoute,
  AppSymbolChainIdSymbolRoute: AppSymbolChainIdSymbolRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface DesignSystemRouteChildren {
  DesignSystemSlugRoute: typeof DesignSystemSlugRoute
  DesignSystemIndexRoute: typeof DesignSystemIndexRoute
}

const DesignSystemRouteChildren: DesignSystemRouteChildren = {
  DesignSystemSlugRoute: DesignSystemSlugRoute,
  DesignSystemIndexRoute: DesignSystemIndexRoute,
}

const DesignSystemRouteWithChildren = DesignSystemRoute._addFileChildren(
  DesignSystemRouteChildren,
)

interface StartRouteChildren {
  StartStepIdRoute: typeof StartStepIdRoute
}

const StartRouteChildren: StartRouteChildren = {
  StartStepIdRoute: StartStepIdRoute,
}

const StartRouteWithChildren = StartRoute._addFileChildren(StartRouteChildren)

interface WelcomeRouteChildren {
  WelcomeStepIdRoute: typeof WelcomeStepIdRoute
}

const WelcomeRouteChildren: WelcomeRouteChildren = {
  WelcomeStepIdRoute: WelcomeStepIdRoute,
}

const WelcomeRouteWithChildren =
  WelcomeRoute._addFileChildren(WelcomeRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AiSandboxRoute: AiSandboxRoute,
  ApiRoute: ApiRoute,
  DesignSystemRoute: DesignSystemRouteWithChildren,
  DevelopersRoute: DevelopersRoute,
  LoginRoute: LoginRoute,
  OnboardingV1PreviewRoute: OnboardingV1PreviewRoute,
  PlatformRoute: PlatformRoute,
  PolicyRoute: PolicyRoute,
  StartRoute: StartRouteWithChildren,
  TermsRoute: TermsRoute,
  WelcomeRoute: WelcomeRouteWithChildren,
  RSlugRoute: RSlugRoute,
  OnrampRobinhoodCallbackRoute: OnrampRobinhoodCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
